import { MousePointer } from 'lucide-react';
import { getNodeIconClass, getTypeLabel } from './nodeUtils';

export default function NodeHeader({ id, data, nodeType, isStart, palette }) {
    const nodeIndex = (() => {
        if (isStart || typeof data?.getNodes !== 'function') return null;
        const sorted = data.getNodes()
            .filter((n) => !n.data?.isStart && n.id !== 'start')
            .sort((a, b) => (a.position?.y ?? 0) - (b.position?.y ?? 0));
        const i = sorted.findIndex((n) => n.id === id);
        return i >= 0 ? i + 1 : null;
    })();

    return (
        <div className="flex items-center justify-between gap-2">
            <div className="flex items-center gap-2">
                <span
                    className={
                        'inline-flex h-6 w-6 items-center justify-center rounded-full text-[10px] ' +
                        (isStart ? 'bg-emerald-500 text-black' : `${palette.badgeBg} text-black`)
                    }
                >
                    {isStart ? (
                        <i className="fas fa-play" />
                    ) : nodeType === 'entregavel' ? (
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z" />
                            <path d="M12 22V12" />
                            <polyline points="3.29 7 12 12 20.71 7" />
                            <path d="m7.5 4.27 9 5.15" />
                        </svg>
                    ) : nodeType === 'buttons' ? (
                        <MousePointer size={12} />
                    ) : (
                        <i className={getNodeIconClass(nodeType)} />
                    )}
                </span>
                <div className="flex text-[11px] font-semibold leading-tight">
                    {isStart ? 'Início' : getTypeLabel(nodeType)}
                    {nodeIndex != null && (
                        <div className="ml-2 text-[11px] text-white/75 leading-tight">#{nodeIndex}</div>
                    )}
                </div>
            </div>

            {!isStart && (
                <div className="flex items-center gap-1.5">
                    <button
                        type="button"
                        className="text-[10px] text-gray-400 hover:text-sky-400 transition-colors"
                        onClick={(e) => { e.stopPropagation(); data?.onDuplicate?.(id); }}
                        title="Duplicar bloco"
                    >
                        <i className="fas fa-copy" />
                    </button>
                    <button
                        type="button"
                        className="text-[10px] text-red-400 hover:text-red-300 transition-colors"
                        onClick={(e) => { e.stopPropagation(); data?.onDelete?.(id); }}
                        title="Excluir bloco"
                    >
                        <i className="fas fa-trash" />
                    </button>
                </div>
            )}
        </div>
    );
}
